// extracted by mini-css-extract-plugin
module.exports = {"container":"_d2e8d0a4","innerContainer":"_1e76fd3a","detailsWrapper":"_8f5f1912"};